import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { GetReceivedLinesParams, ReceiveApiAdapter } from '../adapters/ReceiveApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const receiveAdapter = new ReceiveApiAdapter(httpClient);

export const useReceivedLines = (
    receptionId: number,
    params?: GetReceivedLinesParams,
    enabled: boolean = true
) => {
    return useQuery({
        queryKey: ['received-lines', receptionId, params],
        queryFn: () => receiveAdapter.getReceivedLines(receptionId, params),
        enabled: enabled && !!receptionId,
    });
};

